import { CheckIcon, LoadingIcon } from 'icons'
import { Component, createEffect, createMemo, on, Show } from 'solid-js'
import { clamp } from 'utils/tools'

import './style/passcheck.scss'

interface PassCheckProps {
    pass: string
    show: boolean

    maxLength: number

    onPassed(b: boolean): void
}
export const PassCheck: Component<PassCheckProps> = P => {
    let hintsRef: HTMLElement

    createEffect(
        on(
            () => P.show,
            s => {
                if (!hintsRef) return

                if (!s) {
                    hintsRef.style.opacity = '0'
                    hintsRef.style.maxHeight = '0px'
                    return
                }

                let height = hintsRef.scrollHeight

                hintsRef.style.maxHeight = `${height}px`
                hintsRef.style.opacity = '1'
            }
        )
    )

    createEffect(
        on(
            () => P.pass,
            () => {
                return P.onPassed(
                    status().hasMaxLength &&
                        status().hasLower &&
                        status().hasNum &&
                        status().hasUpper
                )
            }
        )
    )

    const status = createMemo(() => {
        const pw = P.pass

        return {
            hasMaxLength: pw.length >= P.maxLength,
            hasNum: /\d/.test(pw),
            hasLower: /[a-z]/.test(pw),
            hasUpper: /[A-Z]/.test(pw),
        }
    })

    return (
        <div class='hints' ref={e => (hintsRef = e)}>
            <div class='length-bar'>
                <div class='bar'>
                    <div
                        class='inner'
                        classList={{ green: P.pass.length >= 12 }}
                        style={{
                            transform: `translateX(${(clamp(P.pass.length, 0, P.maxLength) / P.maxLength) * 100 - 100}%)`,
                        }}
                    ></div>
                </div>
                <div class='labels'>
                    <p class='title_small holder'>{P.maxLength}</p>
                    <p class='title_small data'>{P.pass.length}</p>
                </div>
            </div>
            <div class='hint-list title_small'>
                <div class='hint-item'>
                    <div
                        class='status icon'
                        classList={{ check: status().hasMaxLength }}
                    >
                        <Show
                            when={!status().hasMaxLength}
                            fallback={<CheckIcon />}
                        >
                            <LoadingIcon />
                        </Show>
                    </div>
                    رمز عبور حداقل 12 حرف باشد
                </div>

                <div class='hint-item'>
                    <div
                        class='status icon'
                        classList={{ check: status().hasNum }}
                    >
                        <Show when={!status().hasNum} fallback={<CheckIcon />}>
                            <LoadingIcon />
                        </Show>
                    </div>
                    رمز عبور دارای حداقل 1 عدد باشد
                </div>

                <div class='hint-item'>
                    <div
                        class='status icon'
                        classList={{ check: status().hasLower }}
                    >
                        <Show
                            when={!status().hasLower}
                            fallback={<CheckIcon />}
                        >
                            <LoadingIcon />
                        </Show>
                    </div>
                    رمز عبور دارای حداقل 1 حرف کوچک باشد
                </div>

                <div class='hint-item'>
                    <div
                        class='status icon'
                        classList={{ check: status().hasUpper }}
                    >
                        <Show
                            when={!status().hasUpper}
                            fallback={<CheckIcon />}
                        >
                            <LoadingIcon />
                        </Show>
                    </div>
                    رمز عبور دارای حداقل 1 حرف بزرگ باشد
                </div>
            </div>
        </div>
    )
}
